import { HHStack } from '@hinge-health/react-component-library';
import { DynamicDrawerProvider } from '../../billing-tool/context/dynamic-drawer.context';
import SubscriptionEstimatesGrid from '../components/subscription-estimates-grid/grid';

export const SUBSCRIPTION_ESTIMATES_TEST_ID =
  'subscription-estimates-container';

// SnackbarProvider is provided by the accounting route tree; the drawer
// provider is scoped here so the add/edit drawer renders alongside the grid.
const SubscriptionEstimates = (): JSX.Element => (
  <DynamicDrawerProvider>
    <HHStack
      flex={1}
      minHeight="0"
      direction="column"
      sx={{ overflow: 'auto' }}
      data-testid={SUBSCRIPTION_ESTIMATES_TEST_ID}
    >
      <SubscriptionEstimatesGrid />
    </HHStack>
  </DynamicDrawerProvider>
);

export default SubscriptionEstimates;
